import { NotificationSettingSection } from "@/features/user-settings/components/NotificationSettingSection";
import { TUserSettingForm } from "@/features/user-settings/types/user-setting-form";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const NotificationEditField: FC = () => {
  const { setValue } = useFormContext<TUserSettingForm>();
  const value = useWatch<TUserSettingForm>({ name: "emailDeliveryOptions" });

  return (
    <NotificationSettingSection
      variant="edit"
      value={Array.isArray(value) ? value : []}
      onChange={(next) => setValue("emailDeliveryOptions", next, { shouldDirty: true, shouldValidate: true })}
    />
  );
};
